<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="query_con">
      <div class="face_content">
        <div class="face_con_left">
          <h1 class="face_con_tit">
            本次考试需要启用手机摄像头实时监控
            <!-- <p>
              请在手机APP端扫以下二维码，并按提示操作，直到以下方框显示你的监控画面
            </p> -->
            <div class="face_con_tit">
              <div class="face_yanzhen">
                <span style="border:0px">
                  <div id="qrcode" style="width:400px; display: inline-block;" v-show="!isShowNext"></div>
                  <!-- <div id="tcplayer1" style="width:400px; display: inline-block; pointer-events: none;" v-show="isShowNext">
                  </div> -->
                  <video id="tcplayer1" ref="tcplayer1" style="width:400px; height:400px; margin: 0 auto; display: inline-block; pointer-events: none;" preload="auto" v-show="isShowNext"></video>
                  <p v-show="!isShowNext">正在等待监控端连接... </p>
                  <a class="face_yanzhen_btn" href="javascript:void(0);" @click="nextStep()" v-show="isShowNext" >我已调整好角度，下一步</a>
                </span>
              </div>
            </div>
          </h1>
        </div>
        <div class="face_con_right">
          <h1 class="face_con_tit face_right_tit">使用流程:</h1>
           1、通过<a class="qrcodeHint" style="color:blue">点此扫码下载</a>或在应用市场搜索“全能考试系统”安装APP
          <div class="appQrcode2">
            <img src="app_qrcode.png" style="width: 100%;">
          </div>
          <p> 2、登录APP</p>
          <p> 3、打开“个人中心”->“扫一扫”左边的二维码</p>
          <p> 4、按以下参考图调整摆放好手机监控角度</p>
          <img src="position.jpg" style="width: 100%;">
          <p style="margin-top: -40px; text-align: center;color: #FFF;font-size: 14px;">参考图</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getExamById, logout, myInfo, liveParams, sendStopPushStreamMsg, updateExamUserFirstPhone } from "@/api/login";
import QRCode from "qrcodejs2";
import COS from "cos-js-sdk-v5";
// import { TcPlayer } from '@/components/TcPlayer/TcPlayer-module-2.4.5';
// import 'tcplayer.js/dist/tcplayer.min.css';

import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';

const cos = new COS({
  SecretId: "AKIDWpshESOHvGK9l9HyC8nCVdfeMp1xJ2Wk",
  SecretKey: "6zpPkpcPwwe5vBCyjESP5UcT2lEQr1Ok"
});

/**
 * 日期格式化
 * 这个函数接受两个参数，第一个参数是要格式化的日期时间，可以是 Date 对象或表示日期时间的字符串，第二个参数是要格式化的格式，例如 yyyy-MM-dd HH:mm:ss。该函数会将日期时间格式化为指定的格式，并返回格式化后的字符串。
 * 该函数使用了正则表达式来匹配格式字符串中的占位符，然后根据对应的日期时间值来替换占位符。其中，y 会被替换为年份，M、d、h、H、m、s、q、S、a、A 分别表示月份、日期、小时（12 小时制）、小时（24 小时制）、分钟、秒、季度、毫秒、上午/下午、AM/PM。
 * 使用该函数进行日期时间格式化的示例如下：
 * const date = new Date();
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss')); // 2023-02-16 08:25:05
 * console.log(formatDateTime(date, 'yyyy年MM月dd日 HH:mm:ss')); // 2023年02月16日 08:25:05
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss S')); // 2023-02-16 08:25:05 950
 * console.log(formatDateTime(date, 'yyyy-MM-dd hh:mm:ss A')); // 2023-02-16 08:25:05 上午
 * 可以根据实际需要修改格式化的格式，以及支持更多的占位符和格式化选项。
 * @param date 
 * @param format 
 */
 function formatDateTime(date, format) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
    A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return format;
}

export default {
  name: "backCameraQrcode",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: ""
      },
      testInfo: {},
      userInfo: {},
      examUserId: "",
      allowResume: "",
      uploadUrl: process.env.VUE_APP_RETURN_URL,
      liveConfig: {},
      websocket: null,
      player: null,
      isShowNext: false,
      timer:{}
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;
    this.initData();
    //启动心跳检测
    this.timer = window.setInterval(this.ping,50000);
  },
  destroyed() {
    this.websocket.close();
    // 页面销毁，同时也销毁 TcPlayer
    this.player.dispose();
    window.clearInterval(this.timer);
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      console.log(this.tokenBean);
      liveParams(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.liveConfig = res.data;
          console.log(this.liveConfig);
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });

      getExamById(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.testInfo = res.data;
          console.log(this.testInfo);
          this.allowResume = this.testInfo.allowResume;
          if(this.testInfo.backCamera === 2) {
            sendStopPushStreamMsg(this.tokenBean);
          }
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });
      myInfo(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
          this.crateQrcode();
        } else {
          this.$message.error(res.data.message);
        }
      });

      if('WebSocket' in window) {
        //websocket地址
        var websocketUrl = process.env.VUE_APP_WEBSOCKET_URL+this.examUserId+"/exam";
        console.log(websocketUrl);
        this.websocket = new WebSocket(websocketUrl);
      } else {
        alert('当前浏览器不支持websocket通讯，请升级浏览器')
      }
      
      //连接发生错误的回调方法
      this.websocket.onerror = function() {
        console.log("与服务器通信发生错误");
        window.clearInterval(this.timer);
      };

      //连接成功建立的回调方法
      this.websocket.onopen = function() {
        console.log("WebSocket连接成功");
      };
      //接收到消息的回调方法
      var self = this;
      this.websocket.onmessage = function(event) {
        console.log(event);
        console.log("收到消息："+event.data);
        // 用户已开始推流
        if (event.data.startsWith("COMMAND_PUSHING")) {
          self.isShowNext = true;
          self.$refs.tcplayer1.style.display = "inline-block";
          self.playStream();
        }
      };

      //连接关闭的回调方法
      this.websocket.onclose = function(e) {
        window.clearInterval(this.timer);
        console.log("WebSocket连接已关闭:"+e.code+" "+e.reason+" "+e.wasClean);
        console.log(e);
      };

    },

    ping(){
      this.websocket.send("ping");
      console.info("ping!");
    },

    /*
    playStream() {
      // webrtc://play.bwkonline.com/examai/29435_monitor
      var playUrl = "webrtc://"+this.liveConfig.playDomain+"/"+this.liveConfig.appName+"/"+this.examUserId+"_monitor";
      console.log(playUrl);

      if(this.player!=null) {
        this.player.dispose();
      }
      let dom = document.getElementById("tcplayer1");
      while (dom.hasChildNodes()) {
        // 当存在子节点时，销毁第一个子节点
        dom.removeChild( dom.childNodes[0] );
      }

      console.log(dom);
      var self = this;
      this.player = new TcPlayer("tcplayer1", {
        webrtc: playUrl,
        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        // poster: "http://www.test.com/myimage.jpg",
        flash: false,
        h5_flv: true,
        width: 400, //视频的显示宽度，请尽量使用视频分辨率宽度
        height: 400, //视频的显示高度，请尽量使用视频分辨率高度
        live: true,
        volume: 0,
        clarity: "sd",
        controls: "none",
        wording: {
          2: "手机网络不稳定",
          1002: "手机网络不稳定"
        },
        listener: function(msg){
          //console.log(msg);
          if(msg.type==='webrtcstatupdate') {
            if(msg.src.playState==='PLAYING') {
              self.isShowNext = true;
            }
            else {
              self.isShowNext = false;
            }
          }
          else if(msg.type==='webrtcstop') {
            self.isShowNext = false;
            return;
          }
        }
      });
    },
    */

    playStream() {
      // webrtc://play.bwkonline.com/examai/29435_monitor
      let playUrl = "webrtc://"+this.liveConfig.playDomain+"/"+this.liveConfig.appName+"/"+this.examUserId+"_monitor";

      this.player = new TCPlayer("tcplayer1", {
        autoplay: true,
        controls: false,
        muted: true,
        controls: false,
        webrtcConfig: {connectRetryCount: 1, receiveAudio: false, showLog: false},
      });
      
      let mythis = this;
      this.player.on('error', function(event) {
        // 做一些处理
        console.log(event);
        mythis.isShowNext = false;
      });
      this.player.on('webrtcevent', function(event) {
        // 做一些处理
        console.log(event);
      });
      this.player.on('playing', function(event) {
        console.log(event);
        mythis.isShowNext = true;
      });

      this.player.src(playUrl);
      console.log(this.player);
    },

    // 发送消息
    send(content) {
      console.log("发送消息："+content);
      this.websocket.send(content);
    },
    
    // 创建二维码
    crateQrcode() {
      // 生成一个网址，如果用浏览器扫码，则显示“请用考试端APP扫码”
      console.log(this.userInfo);
      let qrContent = process.env.VUE_APP_BASE_API + "/api/exam/monitor?examUserId="+this.examUserId+"&userId="+this.userInfo.userId;
      console.log(qrContent);
      setTimeout(() => {
        this.qr = new QRCode("qrcode", {
          width: 400, //宽度
          height: 400,            // 高度
          text: qrContent,      // 二维码内容
          render: "canvas",        // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        });
        this.qr._el.title = "";
      }, 500);
    },
    nextStep() {
      // 启用人脸识别(腾讯人脸核身)
      /*
      if (this.testInfo.loginDetect === 2) {
        if (this.userInfo.faceStatus != 3) {
          alert("考生还没有头像相片，先进行头像相片采集");
          this.$router.push("/profile");
          return;
        }
        createH5FaceOrder(this.tokenBean).then(res => {
          console.log(res.data);
          const callBackUrl = encodeURIComponent(
            this.uploadUrl + this.examUserId
          );
          this.redirectUrl =
            "https://ida.webank.com/api/pc/login?webankAppId=" +
            res.data.config.wbappid +
            "&version=" +
            res.data.config.version +
            "&nonce=" +
            res.data.config.nonce +
            "&orderNo=" +
            res.data.result.data.orderNo +
            "&h5faceId=" +
            res.data.result.data.faceId +
            "&url=" +
            callBackUrl +
            "&userId=" +
            res.data.result.data.userId +
            "&sign=" +
            res.data.result.data.sign;
            console.log(this.redirectUrl);
            window.location.href = this.redirectUrl;
        });
        return;
      }
      */

      this.takePhoneDlg();
      // 进入确认
      this.$router.push({
          path: "/examConfirm",
          query: { examUserId: this.examUserId }
      });
      
      // this.$router.push({
      //   path: "/examCatalog",
      //   query: { examUserId: this.examUserId }
      // });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    },
    exit() {
      this.$router.push("/curExam");
    },

    // 拍照
    takePhoneDlg() {
      //弹出截取的图片并确认、保存到腾讯云
      // tcplayer1_html5_api
      //const video = this.player.video.el;
      const video = this.$el.querySelector('#tcplayer1_html5_api');
      console.log(video);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let imgBase64 = canvas.toDataURL('image/png');
      //console.log(imgBase64);
      
      let that = this;
      this.autoUpload(this.convertBase64UrlToBlob(imgBase64), function(err, data) {
        if (data.statusCode === 200) {
            let phoneUrl = "https://" + data.Location;
            let param = {
              "token":that.tokenBean.token,
              "examUserId":that.examUserId,
              "faceUrl":phoneUrl
            }
            console.log(param);
            updateExamUserFirstPhone(param).then(res => {
                console.log(res);
            });
        } else {
          console.log(err);
        }
      });
    },

    // 上传文件
    autoUpload(fileBase64, callback) {
      const Bucket = "exam-1254560009";
      const Region = "ap-guangzhou";
      var mydate = new Date();
      // var uuid =
      //   this.userInfo.loginName +
      //   mydate.getFullYear() +
      //   (mydate.getMonth() + 1) +
      //   (mydate.getDate() ) +
      //   mydate.getHours() +
      //   mydate.getMinutes() +
      //   mydate.getSeconds() +
      //   mydate.getMilliseconds() +
      //   (1000 + Math.round(Math.random() * 9998)) +
      //   ".png";

      var uuid = this.userInfo.userId + formatDateTime(mydate,"yyyyMMddHHmmssS") + (1000 + Math.round(Math.random() * 9998)) + ".png";
      this.fileName = uuid;
      // var Key = "https://exam-1254560009.cos.ap-guangzhou.myqcloud.com/answer/" + file.name; // 这里指定上传目录和文件名
      var Key = "face/" + uuid; // 这里指定上传目录和文件名
      cos.putObject(
        {
          Bucket: Bucket /* 必须 */,
          Region: Region /* 存储桶所在地域，必须字段 */,
          Key: Key /* 必须 */,
          StorageClass: "STANDARD",
          Body: fileBase64, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        },
        function(err, data) {
          console.log(err || data);
          callback(err, data);
        }
      );
    },

    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/png" });
    },

  }
};
</script>
<style scoped>
.appQrcode2 {
  display: none;
}
.qrcodeHint:hover + .appQrcode2 {
  display: block;
}

</style>